













































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { roundify } from '@/scenario-tester';

@Component({
  components: {},
})
export default class ScenarionTesterRow extends Vue {
  @Prop({ required: true }) readonly row: ScenarioRow;

  @Prop({ required: true }) readonly showOutcome: boolean;

  @Prop({ default: 'none' }) readonly compare:
    | 'in'
    | 'out'
    | 'deleted'
    | 'added'
    | 'equal'
    | 'none';

  roundify = roundify;
}
